import { DS_SIZE } from "@/src/design_system/shared/types/size";
import type { ObjectValues } from "@/src/shared/types/objectValues";

export const DS_THUMBNAIL_SIZES = {
  ExtraSmall: DS_SIZE.ExtraSmall,
  Small: DS_SIZE.Small,
  Medium: DS_SIZE.Medium,
  Large: DS_SIZE.Large,
  ExtraLarge: DS_SIZE.ExtraLarge,
} as const;

export type DSThumbnailSize = ObjectValues<typeof DS_THUMBNAIL_SIZES>;
